var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.665 8.833V15.5a1 1 0 0 1-1 1H5.332a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h5v2.833a2.5 2.5 0 0 0 2.5 2.5zm-.463-1-3.85-4.024-.02-.02v2.544a1.5 1.5 0 0 0 1.5 1.5zM3.332 4.5a2 2 0 0 1 2-2h5.297a2 2 0 0 1 1.445.617l4.036 4.22a2 2 0 0 1 .555 1.382V15.5a2 2 0 0 1-2 2H5.332a2 2 0 0 1-2-2z",
  clipRule: "evenodd"
})));
export default SvgDocumentIcon;